<template>
    <ContainerLayout :loading="loading">
        <template v-slot:navbar>
            <div id="navbar" class="w-100">
                <div class="container-md">
                    <div class="p-3 px-md-0 w-100 d-flex flex-row justify-content-center align-items-center">
                        <div id="div-logo">
                            <font-awesome-icon icon="otter" class="text-dark fs-3" />
                            <span class="text-dark ms-2 fw-bolder d-md-inline d-none fs-3">
                                {{ $t('Portfolio') }}
                            </span>
                        </div>
                        <div id="div-download" class="ms-auto">
                            <button class="btn btn-dark rounded-pill px-4 py-2" @click="downloadCv">
                                <span>
                                    Download CV
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div id="content" class="h-100">
            <div id="main-content" class="h-100">
                <div v-for="(section, index) in sections" :key="index" :ref="setSectionRef"
                    :class="section < 4 ? 'container-md' + (section < 3 ? ' h-100' : '') : ''" style="position: relative;">
                    <div v-if="section == 1" class="h-100 d-flex flex-column justify-content-center align-items-center">
                        <div class="d-flex justify-content-center align-items-center"
                            :class="screen() === 'xs' ? 'flex-column' : 'flex-row'">
                            <div class="d-flex flex-column">
                                <img src="@/assets/images/unnamed.jpg"
                                    style="width: auto; height: 150px; border-radius: 50rem; border: 5px solid #000;" />
                            </div>
                            <div class="d-flex flex-column pt-2 pt-sm-0 px-4">
                                <span class="text-dark fw-bolder fs-1">
                                    {{ $t('Hello') }},
                                </span>
                                <span class="text-dark fw-bolder fs-5">
                                    {{ $t('I am') }} <span>Dani Andhika Permana</span>
                                </span>
                                <span class="text-muted fs-6">
                                    Full Stack Developer | Mobile Developer
                                </span>
                            </div>
                        </div>
                        <div class="scroll-downs" @click="handleScroll">
                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-dark fs-2" />
                        </div>
                    </div>
                    <div v-if="section == 2"
                        class="h-100 mt-5 d-flex flex-column justify-content-center align-items-center text-center section-padding">
                        <span class="text-dark fw-bolder fs-1">
                            {{ $t('About Me') }}
                        </span>
                        <div class="my-4">
                            <span class="text-muted fs-6">
                                {{ aboutMe }}
                            </span>
                        </div>
                        <div class="mt-4">
                            <div class="w-100 d-flex flex-row">
                                <div class="pe-2" style="width: 50%;">
                                    <div class="row g-3 d-flex justify-content-end">
                                        <div v-for="(skill, index) in leftSkills" :key="index"
                                            class="col-6 col-md-4 col-lg-3 d-flex justify-content-center align-items-center">
                                            <div :tooltip="skill.name" style="width: fit-content;">
                                                <font-awesome-icon v-if="skill.icon_type == 'icon'" :icon="skill.icon"
                                                    class="text-dark icon-tools" @click="openUrl(skill.url)" />
                                                <img v-else :src="skill.icon" class="photo-tools"
                                                    @click="openUrl(skill.url)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ps-2" style="width: 50%;">
                                    <div class="row g-3 d-flex justify-content-start">
                                        <div v-for="(skill, index) in rightSkills" :key="index"
                                            class="col-6 col-md-4 col-lg-3 d-flex justify-content-center align-items-center">
                                            <div :tooltip="skill.name" style="width: fit-content;">
                                                <font-awesome-icon v-if="skill.icon_type == 'icon'" :icon="skill.icon"
                                                    class="text-dark icon-tools" @click="openUrl(skill.url)" />
                                                <img v-else :src="skill.icon" class="photo-tools"
                                                    @click="openUrl(skill.url)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="scroll-downs" @click="handleScroll">
                            <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-dark fs-2" />
                        </div>
                    </div>
                    <div v-if="section == 3" class="mt-5 d-flex flex-column justify-content-center align-items-center">
                        <span class="text-dark fw-bolder fs-1">
                            {{ $t('Experience') }}
                        </span>
                        <div class="w-100 my-4">
                            <ul class="d-flex justify-content-center nav nav-tabs nav-justified" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link nav-left py-3 active" id="pills-work-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-work" type="button" role="tab" aria-controls="pills-work"
                                        aria-selected="true">
                                        <div>
                                            {{ $t('Work Tab') }}
                                        </div>
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link nav-right py-3" id="pills-project-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-project" type="button" role="tab"
                                        aria-controls="pills-project" aria-selected="false">
                                        <div>
                                            {{ $t('Project Tab') }}
                                        </div>
                                    </button>
                                </li>
                            </ul>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-work" role="tabpanel"
                                    aria-labelledby="pills-work-tab" tabindex="0">
                                    <div class="w-100 accordion" id="accordionJob">
                                        <div v-for="(job, index) in jobs" :key="index" class="accordion-item">
                                            <h2 class="accordion-header" :id="'heading' + index">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" :data-bs-target="'#collapse' + index"
                                                    aria-expanded="false" :aria-controls="'collapse' + index">
                                                    <div class="job-photo-container me-2 me-sm-4 ">
                                                        <img :src="job.photo" class="job-photo"
                                                            @click.prevent="openUrl(job.url)">
                                                    </div>
                                                    <div class="d-flex flex-column">
                                                        <span class="text-dark fw-bolder fs-6">
                                                            {{ job.position }}
                                                        </span>
                                                        <small class="text-muted my-1">
                                                            {{ job.name }}
                                                        </small>
                                                        <small class="text-muted">
                                                            {{ job.start_date + ' - ' + job.end_date }}
                                                        </small>
                                                    </div>
                                                </button>
                                            </h2>
                                            <div :id="'collapse' + index" class="accordion-collapse collapse"
                                                :aria-labelledby="'heading' + index" data-bs-parent="#accordionJob">
                                                <div class="accordion-body">
                                                    <JobCarousel :data="job" :type="'experience'" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-project" role="tabpanel"
                                    aria-labelledby="pills-project-tab" tabindex="0">
                                    <div class="w-100 accordion" id="accordionProject">
                                        <div v-for="(project, index) in projects" :key="index" class="accordion-item">
                                            <h2 class="accordion-header" :id="'headingProject' + index">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" :data-bs-target="'#collapseProject' + index"
                                                    aria-expanded="false" :aria-controls="'collapseProject' + index">
                                                    <div class="job-photo-container me-2 me-sm-4 ">
                                                        <img :src="project.photo" class="job-photo">
                                                    </div>
                                                    <div class="d-flex flex-column">
                                                        <span class="text-dark fw-bolder fs-6">
                                                            {{ project.name }}
                                                        </span>
                                                        <small class="text-muted my-1">
                                                            {{ project.position }}
                                                        </small>
                                                        <small class="text-muted">
                                                            {{ project.start_date }}
                                                            {{ project.end_date && project.end_date != '' ? '- ' +
                                                                project.end_date : ''
                                                            }}
                                                        </small>
                                                    </div>
                                                </button>
                                            </h2>
                                            <div :id="'collapseProject' + index" class="accordion-collapse collapse"
                                                :aria-labelledby="'headingProject' + index"
                                                data-bs-parent="#accordionProject">
                                                <div class="accordion-body">
                                                    <JobCarousel :data="project" :type="'project'" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="section == 4" class="mt-5 d-flex flex-column justify-content-center align-items-center">
                        <div class="footer-content">
                            <div class="footer">
                                <span class="fw-bolder fs-5">
                                    {{ $t('Contact Me') }}
                                </span>
                                <div class="w-100 py-3 mx-0 row g-3 d-flex justify-content-center">
                                    <div v-for="(contact, index) in contacts" :key="index"
                                        class="col-3 col-md-2 col-lg-1 d-flex justify-content-center align-items-center">
                                        <div :tooltip="contact.name" style="width: fit-content;">
                                            <font-awesome-icon v-if="contact.icon_type == 'icon'" :icon="contact.icon"
                                                class="icon-tools" @click="openUrl(contact.url)" />
                                            <img v-else :src="contact.icon" class="photo-tools"
                                                @click="openUrl(contact.url)" />
                                        </div>
                                    </div>
                                </div>
                                <span class="fw-bolder fs-5 mt-4">
                                    {{ $t('Made with') }}
                                </span>
                                <div class="w-100 py-3 mx-0 row g-3 d-flex justify-content-center">
                                    <div v-for="(frameworks, index) in frameworks" :key="index"
                                        class="col-3 col-md-2 col-lg-1 d-flex justify-content-center align-items-center">
                                        <div :tooltip="frameworks.name" style="width: fit-content;">
                                            <font-awesome-icon v-if="frameworks.icon_type == 'icon'" :icon="frameworks.icon"
                                                class="icon-tools" @click="openUrl(frameworks.url)" />
                                            <img v-else :src="frameworks.icon" class="photo-tools"
                                                @click="openUrl(frameworks.url)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-copyright">
                                <small>
                                    {{ copyright }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>

<script>
import ContainerLayout from "./ContainerLayout.vue";
import screenSize from "@/plugins/screen-size";
import skillData from '@/assets/json/skillData.json';
import jobData from '@/assets/json/jobData.json';
import projectData from '@/assets/json/projectData.json';
import footerData from '@/assets/json/footerData.json';
import JobCarousel from "./JobCarousel.vue";

export default {
    name: "HomeIndex",
    components: {
        ContainerLayout,
        JobCarousel,
    },
    computed: {
        supportedLocales() {
            return ['id', 'en'];
        },
    },
    // mounted() {
    //     //
    // },
    // beforeUnmount() {
    //     //
    // },
    data() {
        return {
            loading: false,
            selectedLocale: localStorage.getItem('locale') ?? this.$i18n.locale,
            leftSkills: skillData.leftSkills,
            rightSkills: skillData.rightSkills,
            jobs: jobData.jobs,
            projects: projectData.projects,
            sections: [1, 2, 3, 4], // your sections data
            sectionRefs: [], // to store refs to each section
            aboutMe: this.$t('aboutMe'),
            copyright: this.$t('copyright', { year: new Date().getFullYear() }),
            contacts: footerData.contacts,
            frameworks: footerData.frameworks,
        };
    },
    setup() {
        const screen = () => {
            return screenSize.size;
        };

        return {
            screen,
        };
    },
    created() {
        //
    },
    watch: {
        //
    },
    methods: {
        openUrl(url) {
            window.open(url, "_blank");
        },

        downloadCv() {
            // download from https://raw.githubusercontent.com/daniandhk/my-portfolio-assets/main/personal/cv.pdf
            window.open('https://raw.githubusercontent.com/daniandhk/my-portfolio-assets/main/personal/CV%20Jan%202024%20-%20Dani%20Andhika%20Permana.pdf', "_blank");
        },

        setSectionRef(el) {
            if (el) {
                this.sectionRefs.push(el);
            }
        },

        handleScroll() {
            const navbar = document.getElementById('navbar'); // Get the navbar element
            const navbarHeight = navbar.offsetHeight; // Height of the navbar

            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop; // Scroll position from the top

            for (let i = 0; i < this.sectionRefs.length; i++) {
                const section = this.sectionRefs[i];
                const sectionTop = section.offsetTop; // Top position of the current section
                const sectionHeight = section.offsetHeight; // Height of the current section

                // Check if the section's top is below the scroll position and its bottom is above the scroll position
                if (scrollPosition + window.innerHeight >= sectionTop + sectionHeight && scrollPosition < sectionTop + sectionHeight) {
                    // Check if it's not the last section
                    if (i < this.sectionRefs.length - 1) {
                        // Calculate the position to scroll to, accounting for the navbar height
                        let positionToScroll = this.sectionRefs[i + 1].offsetTop;
                        if (i == 1) {
                            positionToScroll -= navbarHeight + 40;
                        }
                        else if (this.screen() == 'xs') {
                            positionToScroll -= navbarHeight + 60;
                        }

                        // Scroll to the top of the next section smoothly, adjusting for navbar height
                        window.scrollTo({
                            top: positionToScroll,
                            behavior: 'smooth'
                        });
                    }
                    break;
                }
            }
        },
    }
};
</script>

<style scoped>
@media (min-width: 992px) {
    .container-md {
        padding-left: 125px;
        padding-right: 125px;
    }

    .footer-content {
        margin-left: -125px !important;
        margin-right: -125px !important;
    }
}

@media (min-width: 1200px) {
    .container-md {
        padding-left: 200px;
        padding-right: 200px;
    }

    .footer-content {
        margin-left: -200px !important;
        margin-right: -200px !important;
    }
}

.footer-content {
    width: 100%;
    background-color: #000;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.footer {
    width: 100%;
    padding: 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.footer-copyright {
    width: 100%;
    padding: 6px 12px;
    background-color: #1C1C1C;
}

@keyframes bounce {

    0%,
    20%,
    50%,
    80%,
    100% {
        transform: translateY(0);
    }

    40% {
        transform: translateY(-10px);
    }

    60% {
        transform: translateY(-5px);
    }
}

@keyframes bounce-sides {

    0%,
    20%,
    50%,
    80%,
    100% {
        transform: translateX(0);
    }

    40% {
        transform: translateX(-5px);
    }

    60% {
        transform: translateX(-2.5px);
    }
}

.scroll-downs {
    position: absolute;
    bottom: 0;
    /* Center it horizontally */
    transform: translateX(-50%);
    /* Center it horizontally */
    margin-bottom: 30px;
    margin-top: 60px;
    cursor: pointer;
    animation: bounce 2s infinite;
}

@media (max-width: 576px) {
    .section-padding {
        padding: 0 8px 100px 8px !important;
    }
}

.accordion-button {
    color: #000 !important;
    background-color: #F3F4F6 !important;
}

.accordion-button.collapsed {
    width: 100%;
    background-color: transparent !important;
    border: none !important;
}

.accordion-button:focus {
    box-shadow: none !important;
}

.accordion-button:not(.collapsed):after {
    background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>") !important;
}

.accordion-item:first-of-type {
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
}

.accordion-item:last-of-type {
    border-bottom-right-radius: 1.5rem !important;
    border-bottom-left-radius: 1.5rem !important;
}

.nav-tabs {
    border-bottom: none !important;
}

.nav-left {
    border-right: none !important;
    border-radius: 1.5rem 0 0 0 !important;
}

.nav-right {
    border-left: none !important;
    border-radius: 0 1.5rem 0 0 !important;
}

.nav-link {
    color: #000 !important;
    border: 1px solid #DEE2E6 !important;
}

.nav-link:not(.active) div {
    animation: bounce-sides 2s infinite;
}

.nav-link:not(.active):hover {
    background-color: rgba(150, 150, 150, 0.2) !important;
}

.nav-link.active {
    font-weight: 700 !important;
    background-color: #000 !important;
    color: #fff !important;
    border: 1px solid #000 !important;
}

.nav-link.active:hover {
    background-color: rgba(0, 0, 0, 0.8) !important;
}

.job-photo {
    width: 100px;
    height: auto;
    max-height: 100px;
}

@media (max-width: 576px) {
    .job-photo {
        width: 80px;
        height: auto;
        max-height: 80px;
    }
}

.job-photo:hover {
    cursor: pointer;
    transform: scale(1.1);
}

.job-photo-container {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (max-width: 576px) {
    .job-photo-container {
        width: 80px;
        height: 80px;
    }
}
</style>